import { useEffect, useState } from "react";
import { useGetAllQuestionCategoryQuery } from "src/services/QuestionCategoryServices";

const useQuestionCategory = () => {
  const [questionCategory, setQuestionCategory] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllQuestionCategoryQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setQuestionCategory(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { questionCategory, isDataLoading };
};

export default useQuestionCategory;
